import { sendTealiumEvent, getEnvironment } from ".";
import { UserToQueryStringLangMap } from "./CONSTANTS";
import { UserLanguage, Envs, ChatInit } from "../@types";
import URI from "urijs";
import { openWindowWithPost } from "./windowHelpers";
import { getAPIChatInit } from "../api";
import { isChatInit } from "../@types/guards";

export interface ChatLaunchData extends ChatInit {
  ChatAuth: "Yes";
  TextSize: "smallfont";
}

export const getAPIChatUrlData = async (
  Language: string,
  currentView: string
): Promise<ChatLaunchData | undefined> => {
  const chatInit = await getAPIChatInit({
    Language,
    CurrentView: `MCT-${currentView}`,
  });
  if (isChatInit(chatInit)) {
    return { ...chatInit, ChatAuth: "Yes", TextSize: "smallfont" };
  }
  return undefined;
};

export const getChatUrl = (): URI => {
  const base = "mymedicare.gov/chatclient/chatrequest.aspx";
  const env = getEnvironment();
  let chatUrl = "";

  if (env === Envs.test || env === Envs.local || env === Envs.imp) {
    document.cookie = "ACA=NcAnRSpO1O";
    chatUrl = `https://chat.uat.${base}`;
  } else if (env === Envs.prod) {
    chatUrl = `https://chat.${base}`;
  }

  return new URI(chatUrl);
};

export const launchChat = async (
  language: UserLanguage,
  currentView: string
): Promise<boolean> => {
  sendTealiumEvent("Header", "Live Chat");
  const lang = UserToQueryStringLangMap[language];
  const chatLaunchData = await getAPIChatUrlData(lang, currentView);
  if (chatLaunchData) {
    const launchURI = getChatUrl();
    openWindowWithPost(launchURI, chatLaunchData);
    return true;
  } else {
    return false;
  }
};
